import { crimson } from './fonts'

export function DeluxeBooksRegistryFooter() {
  return (
    <p
      className={`${crimson.className} mx-auto mt-8 max-w-2xl text-center text-base leading-relaxed text-[#7a6a5a]`}
    >
      By joining our exclusive registry, you agree to receive notifications about
      new deluxe edition releases from Vanishing Inc. We respect your privacy
      and you can unsubscribe at any time. Notifications are sent only when new
      deluxe editions become available.
    </p>
  )
}
